import {extendTheme} from '@chakra-ui/react'
import {ButtonStyles as Button} from './ButtonStyles'
import {AlertStyles as Alert} from './AlertStyles'
import {CheckboxStyles as Checkbox} from './CheckboxStyles'
import {RadioStyles as Radio} from './RadioStyles'
import ConsentBox from '../ConsentBox'
import colors from './colors'

export const newTheme = extendTheme({
  fonts: {
    heading: `'Museo Sans', sans-serif`,
    body: `'Museo Sans', sans-serif`,
  },

  textStyles: {
    h1: {
      fontSize: '4.375rem',
    },
    h2: {
      fontSize: '4.125rem',
    },
    h3: {
      fontSize: '3.625rem',
    },
    h4: {
      fontSize: '3.25rem',
    },
    t1: {
      fontSize: '2.875rem',
    },
    t2: {
      fontSize: '2.625rem',
    },
    t3: {
      fontSize: '2.25rem',
    },
    t4: {
      fontSize: '2rem',
    },
    t5: {
      fontSize: '1.8125rem',
    },
    t6: {
      fontSize: '1.625rem',
    },
    t7: {
      fontSize: '1.4375rem',
    },
    b1: {
      fontSize: '1.25rem',
    },
    b2: {
      fontSize: '1.125rem',
    },
    b3: {
      fontSize: '1rem',
    },
    c1: {
      fontSize: '0.875rem',
    },
    c2: {
      fontSize: '0.8125rem',
    },
  },

  components: {
    Button,
    Text,
    Alert,
    Checkbox,
    Radio,
    ConsentBox,
  },
  colors,
})

export default newTheme
